import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { database } from "../../firebase";
import { onValue, ref } from "firebase/database";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from "moment";
import MuiAlert from '@mui/material/Alert';
import { getCuadrillasOnce } from "../../services/cuadrillasService";

export default function ModalFilters({ open, onCloseModal, items }) {
    const { search } = useLocation();
    const [cuadrillas, setCuadrillas] = useState([])
    const [users, setUsers] = useState([])
    const [state, setState] = useState({
        cuadrilla: '',
        cuadrillaReceptora: '',
        cuadrillaEntrega: '',
        nroFormulario: "",
        nroOt: "",
        workOrder: "",
        nroCita: "",
        contrato: "",
        dateTo: null,
        dateFrom: null,
        idRemito: '',
        user: '',
    });
    const [alertValidationDate, setAlertValidationDate] = useState('')

    useEffect(() => {
        // Cargar cuadrillas
        getCuadrillasOnce((cuadrillasData) => {
            console.log('🔧 === CUADRILLAS CARGADAS EN MODAL ===');
            console.log('🔧 Cantidad de cuadrillas:', cuadrillasData?.length || 0);
            if (cuadrillasData && cuadrillasData.length > 0) {
                console.log('🔧 Primeras 5 cuadrillas:', cuadrillasData.slice(0, 5).map(c => ({
                    id: c.id,
                    numero: c.numero,
                    tipo: typeof c.id
                })));
                console.log('🔧 IDs de cuadrillas disponibles:', cuadrillasData.map(c => c.id).sort((a, b) => a - b));
            }
            setCuadrillas(cuadrillasData);
            console.log('🔧 === FIN CUADRILLAS CARGADAS ===');
        });

        // Cargar usuarios desde Firebase Realtime Database
        onValue(ref(database, '/users/'), (snapshot) => {
            console.log('🔧 === USUARIOS CARGADOS EN MODAL ===');
            const usersData = snapshot.val();
            if (usersData) {
                const usersArray = Object.values(usersData);
                console.log('🔧 Cantidad de usuarios:', usersArray.length);
                console.log('🔧 Primeros 3 usuarios:', usersArray.slice(0, 3).map(u => ({
                    email: u.email,
                    nombre: u.nombre || u.name
                })));
                setUsers(usersArray);
            } else {
                console.log('🔧 No se encontraron usuarios');
                setUsers([]);
            }
            console.log('🔧 === FIN USUARIOS CARGADOS ===');
        }, {
            onlyOnce: true
        });
    }, []);

    const createParams = () => {
        // Crear un objeto URLSearchParams para manejar los parámetros de forma acumulativa
        const params = new URLSearchParams();
        
        // Agregar filtros solo si tienen valor
        if (state.cuadrilla !== '') {
            params.append('idCuadrilla', state.cuadrilla);
        }
        if (state.cuadrillaReceptora !== '') {
            params.append('cuadrillaReceptora', state.cuadrillaReceptora);
        }
        if (state.cuadrillaEntrega !== '') {
            params.append('cuadrillaEntrega', state.cuadrillaEntrega);
        }
        if (state.nroFormulario !== '') {
            params.append('nroFormulario', state.nroFormulario);
        }
        if (state.nroOt !== '') {
            params.append('nroOt', state.nroOt);
        }
        if (state.workOrder !== '') {
            params.append('workOrder', state.workOrder);
        }
        if (state.nroCita !== '') {
            params.append('nroCita', state.nroCita);
        }
        if (state.contrato !== '') {
            params.append('contrato', state.contrato);
        }
        if (state.idRemito !== '') {
            params.append('idRemito', state.idRemito);
        }
        if (state.user !== '') {
            params.append('user', state.user);
        }
        if (state.dateFrom !== null && state.dateTo !== null) {
            const formatDateFrom = moment(state.dateFrom).format("YYYYMMDD");
            const formatDateTo = moment(state.dateTo).format("YYYYMMDD");
            params.append('dateFrom', formatDateFrom);
            params.append('dateTo', formatDateTo);
        }
        
        // Siempre agregar page=1 cuando se aplican filtros nuevos
        params.append('page', '1');
        
        // Convertir a string con ? al inicio
        const queryString = params.toString();
        return queryString ? `?${queryString}` : '?page=1';
    }

    const onAcceptFilter = () => {
        console.log('🔍 === APLICANDO FILTROS ===');
        console.log('🔍 Estado actual del formulario:', {
            cuadrilla: state.cuadrilla,
            cuadrillaReceptora: state.cuadrillaReceptora,
            cuadrillaEntrega: state.cuadrillaEntrega,
            nroFormulario: state.nroFormulario,
            nroOt: state.nroOt,
            workOrder: state.workOrder,
            nroCita: state.nroCita,
            contrato: state.contrato,
            idRemito: state.idRemito,
            user: state.user,
            dateFrom: state.dateFrom ? moment(state.dateFrom).format("YYYYMMDD") : null,
            dateTo: state.dateTo ? moment(state.dateTo).format("YYYYMMDD") : null
        });
        
        const completeParams = createParams();
        console.log('🔍 URL completa generada:', completeParams);
        console.log('🔍 === FIN APLICANDO FILTROS ===');
        
        window.location.href = completeParams;
    }

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const clearFilters = () => {
        setState({
            cuadrilla: '',
            cuadrillaReceptora: '',
            cuadrillaEntrega: '',
            nroFormulario: '',
            nroOt: '',
            workOrder: '',
            nroCita: '',
            contrato: '',
            dateTo: null,
            dateFrom: null,
            idRemito: '',
            user: '',
        });
    }

    const onChangeSelectCuadrilla = (event, cuadrilla, name) => {
        console.log('🔧 === SELECCIÓN DE CUADRILLA ===');
        console.log('🔧 Cuadrilla seleccionada:', {
            objeto: cuadrilla,
            id: cuadrilla?.id,
            numero: cuadrilla?.numero,
            name: name,
            tipoId: typeof cuadrilla?.id
        });
        
        const idCuadrilla = cuadrilla.id;
        setState(prevState => ({ ...prevState, [name]: idCuadrilla }));
        
        console.log('🔧 Estado actualizado:', { [name]: idCuadrilla });
        console.log('🔧 === FIN SELECCIÓN CUADRILLA ===');
    }

    const onChangeSelectUser = (event, user) => {
        console.log('🔧 === SELECCIÓN DE USUARIO ===');
        console.log('🔧 Usuario seleccionado:', {
            objeto: user,
            email: user?.email,
            nombre: user?.nombre || user?.name
        });
        
        const userEmail = user?.email || '';
        setState(prevState => ({ ...prevState, user: userEmail }));
        
        console.log('🔧 Estado actualizado:', { user: userEmail });
        console.log('🔧 === FIN SELECCIÓN USUARIO ===');
    }

    const onChangeDateTo = (value) => {
        const d = new Date(value);
        const isValidDate = moment(d).isSameOrBefore(moment(new Date()), 'day');
        if (isValidDate) {
            setState(prevState => ({ ...prevState, dateTo: value }));
            setAlertValidationDate('')
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual')
        }
    };

    const onChangeDateFrom = (value) => {
        const d = new Date(value);
        const isValidDate = moment(d).isSameOrBefore(moment(new Date()), 'day');
        if (isValidDate) {
            setState(prevState => ({ ...prevState, dateFrom: value }));
            setAlertValidationDate('')
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual')
        }
    };

    return (
        <>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Filtros de Búsqueda"}
                </DialogTitle>
                <DialogContent>
                    <span style={{ fontSize: '12px', color: '#666', marginBottom: '15px', display: 'block' }}>
                        * Puede aplicar múltiples filtros de forma simultánea
                    </span>
                    {items.find(item => item === 'cuadrilla') &&
                        <FormControl sx={{ width: '100%', margin: '10px 0' }}>
                            <Autocomplete
                                options={cuadrillas}
                                id="disable-clearable"
                                disableClearable
                                onChange={(e, cuadrilla) => onChangeSelectCuadrilla(e, cuadrilla, 'cuadrilla')}
                                getOptionLabel={(option) => {
                                    if (!option) return '';
                                    if (typeof option === 'string') return option;
                                    const parts = [];
                                    if (option.usuario) parts.push(option.usuario);
                                    if (option.codigo) parts.push(option.codigo);
                                    if (option.numero) parts.push(option.numero);
                                    return parts.join(' - ') || String(option.id || '');
                                }}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField {...params} label="Cuadrilla" placeholder="Cuadrilla" />
                                )}
                            />
                        </FormControl>
                    }
                    {items.find(item => item === 'cuadrillaEntrega') &&
                        <FormControl sx={{ width: '100%', margin: '10px 0' }}>
                            <Autocomplete
                                options={cuadrillas}
                                id="disable-clearable"
                                disableClearable
                                onChange={(e, cuadrilla) => onChangeSelectCuadrilla(e, cuadrilla, 'cuadrillaEntrega')}
                                getOptionLabel={(option) => {
                                    if (!option) return '';
                                    if (typeof option === 'string') return option;
                                    const parts = [];
                                    if (option.usuario) parts.push(option.usuario);
                                    if (option.codigo) parts.push(option.codigo);
                                    if (option.numero) parts.push(option.numero);
                                    return parts.join(' - ') || String(option.id || '');
                                }}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField {...params} label="Cuadrilla Origen" placeholder="Cuadrilla Origen" />
                                )}
                            />
                        </FormControl>
                    }
                    {items.find(item => item === 'cuadrillaReceptora') &&
                        <FormControl sx={{ width: '100%', margin: '10px 0' }}>
                            <Autocomplete
                                options={cuadrillas}
                                id="disable-clearable"
                                disableClearable
                                onChange={(e, cuadrilla) => onChangeSelectCuadrilla(e, cuadrilla, 'cuadrillaReceptora')}
                                getOptionLabel={(option) => {
                                    if (!option) return '';
                                    if (typeof option === 'string') return option;
                                    const parts = [];
                                    if (option.usuario) parts.push(option.usuario);
                                    if (option.codigo) parts.push(option.codigo);
                                    if (option.numero) parts.push(option.numero);
                                    return parts.join(' - ') || String(option.id || '');
                                }}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField {...params} label="Cuadrilla Destino" placeholder="Cuadrilla Destino" />
                                )}
                            />
                        </FormControl>
                    }
                    {items.find(item => item === 'nroFormulario') &&
                        <TextField
                            variant="outlined"
                            fullWidth
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            className="default__textfield"
                            id="nroFormulario"
                            label="Nro Formulario"
                            value={state.nroFormulario}
                            name="nroFormulario"
                            onChange={onChangeValues}
                            sx={{ margin: '10px 0' }}
                        />
                    }
                    {items.find(item => item === 'nroOt') &&

                        <TextField
                            variant="outlined"
                            fullWidth
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            className="default__textfield"
                            id="nroOt"
                            label="Nro. OT"
                            value={state.nroOt}
                            name="nroOt"
                            onChange={onChangeValues}
                            sx={{ margin: '10px 0' }}
                        />
                    }
                    {items.find(item => item === 'workOrder') &&
                        <TextField
                            variant="outlined"
                            fullWidth
                            className="default__textfield"
                            id="workOrder"
                            label="Work Order"
                            value={state.workOrder}
                            name="workOrder"
                            onChange={onChangeValues}
                            sx={{ margin: '10px 0' }}
                        />
                    }
                    {items.find(item => item === 'nroCita') &&
                        <TextField
                            variant="outlined"
                            fullWidth
                            className="default__textfield"
                            id="nroCita"
                            label="Nro. de Cita"
                            value={state.nroCita}
                            name="nroCita"
                            onChange={onChangeValues}
                            sx={{ margin: '10px 0' }}
                        />
                    }
                    {items.find(item => item === 'contrato') &&
                        <TextField
                            variant="outlined"
                            fullWidth
                            className="default__textfield"
                            id="contrato"
                            label="Contrato"
                            value={state.contrato}
                            name="contrato"
                            onChange={onChangeValues}
                            sx={{ margin: '10px 0' }}
                        />
                    }
                    {items.find(item => item === 'user') &&
                        <FormControl sx={{ width: '100%', margin: '10px 0' }}>
                            <Autocomplete
                                options={users}
                                id="user-selector"
                                disableClearable
                                onChange={onChangeSelectUser}
                                getOptionLabel={(option) => `${option.email} ${option.nombre || option.name ? `(${option.nombre || option.name})` : ''}`}
                                fullWidth
                                renderInput={(params) => (
                                    <TextField {...params} label="Usuario" placeholder="Seleccionar usuario" />
                                )}
                            />
                        </FormControl>
                    }
                    {items.find(item => item === 'idRemito') &&
                        <TextField
                            variant="outlined"
                            fullWidth
                            className="default__textfield"
                            id="idRemito"
                            label="ID Remito"
                            value={state.idRemito}
                            name="idRemito"
                            onChange={onChangeValues}
                            sx={{ margin: '10px 0' }}
                        />
                    }
                    {items.find(item => item === 'dateFrom') &&
                        <LocalizationProvider dateAdapter={AdapterMoment} sx={{ marginRight: '10px', width: '50%' }}>
                            <DatePicker
                                className="date-selector"
                                label="Fecha Desde"
                                inputFormat="DD/MM/YYYY"
                                value={state.dateFrom}
                                onChange={onChangeDateFrom}
                                renderInput={(params) => <TextField {...params} />}
                                sx={{ marginRight: '30px', width: '50%' }}
                            />
                        </LocalizationProvider>
                    }
                    {items.find(item => item === 'dateTo') &&
                        <LocalizationProvider dateAdapter={AdapterMoment} sx={{ marginLeft: '10px' }}>
                            <DatePicker
                                className="date-selector-to"
                                label="Fecha Hasta"
                                inputFormat="DD/MM/YYYY"
                                value={state.dateTo}
                                onError={(e, a) => console.log('error', e, a)}
                                onChange={onChangeDateTo}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    }
                    {alertValidationDate !== '' && <MuiAlert severity="error">{alertValidationDate}</MuiAlert>}
                </DialogContent>
                <DialogActions>
                    <Button onClick={clearFilters}>Limpiar Búsqueda</Button>
                    <Button onClick={onCloseModal}>Cancelar</Button>
                    <Button
                        onClick={onAcceptFilter}
                        title="Aplicar filtros seleccionados"
                        disabled={(state.dateFrom !== null && state.dateTo === null) || (state.dateFrom === null && state.dateTo !== null)}
                    >
                        Aplicar Filtros
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
